module.exports = __webpack_public_path__ + "img/1717382394647-PIRTkeripik opatan.png.2eb751b0.webp";